import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

import { useAppStore } from "../../providers/AppStoreProvider";
import { useAPI } from "../../providers/ApiProvider";
import { RatingStar } from "../RatingStar/RatingStar";
import { TOASTIFY_OPTIONS } from "../../config/ReactToastify";

const validateRating = (rating) => {
  if (!rating.star || !rating.review_content || !rating.teacher_star) return false;
  return true;
};

export const RatingModal = observer(() => {
  const store = useAppStore();
  const api = useAPI();
  const [courseRating, setCourseRating] = useState();
  const [teacherRating, setTeacherRating] = useState();
  const [courseReview, setCourseReview] = useState();
  const [teacherReview, setTeacherReview] = useState();

  useEffect(() => {
    if (store.review) {
      setCourseRating(store.review.star);
      setTeacherRating(store.review.teacher_star);
      setCourseReview(store.review.content);
      setTeacherReview(store.review.teacher_content);
    }
  }, []);

  const storeReviewHandler = () => {
    const ratingData = {
      star: courseRating,
      review_content: courseReview,
      teacher_star: teacherRating,
      teacher_content: teacherReview,
    };

    if (!validateRating(ratingData)) {
      toast.error("Hãy điền đủ thông tin");
      return;
    }

    store.ratingModal.setSubmitState(true);
    if (store.ratingModal.mode === "edit") {
      api
        .callApi("updateReview", {
          params: { pk: store.review.id },
          body: { ...ratingData },
        })
        .then((res) => {
          store.setReview(res.data);
          store.ratingModal.toggle();
          toast.success("Cập nhật đánh giá thành công", TOASTIFY_OPTIONS);
        })
        .catch((e) => {
          console.log(e);
          toast.error("Xảy ra lỗi, không thể cập nhật đánh giá", TOASTIFY_OPTIONS);
        })
        .finally((e) => store.ratingModal.setSubmitState(false));
    } else {
      api
        .callApi("createReview", {
          body: {
            course_id: store.course.id,
            teacher_id: store.course.author.id,
            ...ratingData,
          },
        })
        .then((res) => {
          store.setReview(res.data);
          store.ratingModal.toggle();
          toast.success("Đánh giá khoá học thành công", TOASTIFY_OPTIONS);
        })
        .catch((e) => {
          console.log(e);
          toast.error("Xảy ra lỗi, không thể đánh giá khoá học", TOASTIFY_OPTIONS);
        })
        .finally((e) => store.ratingModal.setSubmitState(false));
    }
  };

  return (
    <Modal size="lg" show={store.ratingModal.show} onHide={store.ratingModal.toggle}>
      <Modal.Header closeButton className="border-0">
        <div className="d-flex flex-column me-3">
          <Modal.Title as="h3" className="fw-bold lh-sm mb-2">
            {store.ratingModal.mode === "edit" ? "Cập nhật đánh giá" : "Đánh giá"} khoá học
          </Modal.Title>
          <small className="text-black-50">
            Để lại đánh giá để ColorME có thể cải thiện tốt hơn nhé
          </small>
        </div>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="d-flex flex-column">
            <Form.Label className="fw-bold">Đánh giá khoá học</Form.Label>
            <div>
              <RatingStar
                precision={0.5}
                defaultValue={courseRating}
                onChange={setCourseRating}
                iconSize="xl"
              />
            </div>
          </Form.Group>

          <Form.Group className="mt-4">
            <Form.Label className="fw-bold">Phản hồi về khoá học</Form.Label>
            <Form.Control
              as="textarea"
              name="review"
              rows={4}
              disabled={store.ratingModal.isSubmitting}
              placeholder="Phản hồi về khoá học"
              className="rounded-10 mt-1"
              value={courseReview}
              onChange={(e) => setCourseReview(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mt-5">
            <Form.Label className="fw-bold mb-3">Đánh giá giảng viên</Form.Label>
            <div className="d-flex flex-row align-items-center">
              <div className="avatar avatar-xl rounded-circle overflow-hidden me-2">
                <img src={store.course.author.avatar_url} alt={store.course.author.name} />
              </div>
              <div className="ps-1">
                <div className="lh-sm mb-1">{store.course.author.name}</div>
                <RatingStar
                  precision={0.5}
                  defaultValue={teacherRating}
                  onChange={setTeacherRating}
                  iconSize="lg"
                />
              </div>
            </div>
          </Form.Group>

          <Form.Group className="mt-4">
            <Form.Label className="fw-bold">Góp ý với giảng viên</Form.Label>
            <Form.Control
              as="textarea"
              name="review"
              rows={4}
              disabled={store.ratingModal.isSubmitting}
              placeholder="Góp ý với giảng viên"
              className="rounded-10 mt-1"
              value={teacherReview}
              onChange={(e) => setTeacherReview(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="d-flex flex-row justify-content-end border-0">
        <Button
          variant="outline"
          className="text-black-50 rounded-pill border-0 p-2 px-4"
          onClick={store.ratingModal.toggle}
        >
          Hủy
        </Button>
        <Button
          className="fw-semibold rounded-pill bg-gradient-orange border-0 p-2 px-4"
          onClick={storeReviewHandler}
          disabled={store.ratingModal.isSubmitting}
        >
          {store.ratingModal.isSubmitting && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
          )}

          {store.ratingModal.mode === "edit" ? (
            <span>Cập nhật đánh giá</span>
          ) : (
            <span>Gửi đánh giá</span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
